import { useEffect, useRef, useState } from "react";
import { checkReplaceAggr, replaceAggr } from "../../Services/Api"
import { useMutation } from "@tanstack/react-query";


import useSound from "use-sound";
import err from '../Form/sounds/err.mp3';
import saveSucsess from '../Form/sounds/saveSucsess.mp3';
import { useDebounce } from "../Form/Form2/lib";


/**форма поиска товара по части названия или части артикула 1с */
const Replace = () => {
  const [findSting, setFindString] = useState('');
  const [findResult, setFindResult] = useState('');
  const findRef = useRef(null);

  const [replaceSting, setReplaceSting] = useState('');
  const [replaceResult, setReplaceResult] = useState('');
  const replaceRef = useRef(null);

  const [playErr] = useSound(err);
  const [playSaveSucsess] = useSound(saveSucsess);
  
  useEffect(() => {
    findRef.current.focus();
  }, [])

  const findMutation = useMutation({
    mutationFn: checkReplaceAggr,
    onSuccess: (data) => {
      setFindResult(data?.payload?.resultMessage)
      if (data?.payload?.status === 'ok') {
        playSaveSucsess();
        replaceRef.current.focus();
      } else {
        playErr();
        setFindString('');
        findRef.current.focus();
      }
    },
    onError: (error) => {
      playErr();
      setFindString('');
      findRef.current.focus();
      setFindResult(error?.message ? (`Сетевая ошибка: ${error.message}`) : 'Непредвиденная сетевая ошибка')
    },
  });

  const replaceMutation = useMutation({
    mutationFn: replaceAggr,
    onSuccess: (data) => {
      setReplaceResult(data?.payload?.resultMessage)
      if (data?.payload?.status === 'ok') {
        playSaveSucsess();
        setFindString('');
        setReplaceSting('');
        setFindResult('');
        findRef.current.focus();

      } else {
        playErr();
        setReplaceSting('');
        replaceRef.current.focus();
      }
    },
    onError: (error) => {
      playErr();
      setReplaceSting('');
      replaceRef.current.focus();
      setReplaceResult(error?.message ? (`Сетевая ошибка: ${error.message}`) : 'Непредвиденная сетевая ошибка')
    },
  });


  useDebounce(findSting, 200, (dValue) => {
    if (dValue) {
      findMutation.mutate({findCode: dValue})
    }
  });
  
  useDebounce(replaceSting, 200, (dValue) => {
    if (dValue) {
      replaceMutation.mutate({findCode: findSting, replaceCode: dValue})
    }
  });


  return (
    <>
      <div className="mainForm">
        <div className="gForm cont">
          <h2>Исходный код</h2>
          {findResult !== '' ? (<h3 >{findResult}</h3>) : null}
          <input ref={findRef} type="text" value={findSting} onChange={(e) => setFindString(e.target.value)} />
          <h2>Код для замены</h2>
          {replaceResult !== '' ? (<h3 style={{ color: "red" }}>{replaceResult}</h3>) : null}
          <input ref={replaceRef} type="text" value={replaceSting} onChange={(e) => setReplaceSting(e.target.value)} />
        </div>
      </div>
    </>

  )
}

export default Replace;